export const colorsToLoja = {
	primary: '#009E7F',
	secondary: '#E13D88',
	positive: '#49BC48',
	negative: '#FF433C',
	warning: '#E06C3D',

	white: '#FFFFFF',
	gray1: '#EFEFF4',
	gray2: '#E5E5EA',
	gray3: '#C7C7CC',
	gray4: '#8E8E93',
	gray5: '#707070',
	gray6: '#333333',
	gray7: '#2E2E2E',
	black: '#000000',

	bg: '#F7F7F7',
	defaultText: '#2E2E2E',

	blue: '#93C0E1',

	transparent: 'transparent',
};

export const colorsMakeACoffee = {
	primary: '#431C09',
	secondary: '#E13D88',
	positive: '#49BC48',
	negative: '#FF433C',
	warning: '#E06C3D',

	white: '#FFFFFF',
	gray1: '#EFEFF4',
	gray2: '#E5E5EA',
	gray3: '#C7C7CC',
	gray4: '#8E8E93',
	gray5: '#707070',
	gray6: '#333333',
	gray7: '#2E2E2E',
	black: '#000000',

	bg: '#F7F7F7',
	defaultText: '#2E2E2E',

	blue: '#93C0E1',

	transparent: 'transparent',
};
